import { RequestModuleEnum } from 'shared/enums/request-module-enum'

export const digitalProductRevalidationKeys: RequestModuleEnum[] = [
  RequestModuleEnum.DigitalProducts,

  // Embedded price plans
  RequestModuleEnum.PricePlans,

  // Referenced resources
  RequestModuleEnum.Community,
  RequestModuleEnum.Tags,
  RequestModuleEnum.MembershipCourse,
  RequestModuleEnum.MembershipCourseCurriculum,
  RequestModuleEnum.CourseBundle,
]
